// src/utils/auth.js

// 统一存储 Key
export const USER_ID_KEY = 'medicalUserId';
export const PHONE_KEY = 'medicalUserPhone';
export const STATUS_KEY = 'loginStatus';
export const EXPIRY_KEY = 'medicalUserExpiry';
export const HAS_INVITE_KEY = 'medicalHasInvite';

const FIFTEEN_DAYS_MS = 30 * 24 * 60 * 60 * 1000;

/**
 * 保存登录会话
 * @param {string} userId 
 * @param {string} phone 
 */
export const saveLoginSession = (userId, phone) => {
  const expiry = Date.now() + FIFTEEN_DAYS_MS;
  localStorage.setItem(USER_ID_KEY, userId);
  localStorage.setItem(PHONE_KEY, phone);
  localStorage.setItem(STATUS_KEY, 'logged_in');
  localStorage.setItem(EXPIRY_KEY, expiry.toString());
};

/**
 * 缓存登录接口返回的「是否有邀请资格」
 * 兼容布尔值与 1/0、"true"/"false" 字符串
 * @param {boolean|number|string} hasInvite
 */
export const saveHasInvite = (hasInvite) => {
  if (hasInvite === undefined || hasInvite === null) return;
  const value = typeof hasInvite === 'string'
    ? hasInvite === 'true' || hasInvite === '1'
    : Boolean(hasInvite);
  localStorage.setItem(HAS_INVITE_KEY, value ? '1' : '0');
};

/**
 * 读取是否有邀请资格
 * 未登录过或登录接口未返回该字段时，默认 false（无邀请资格时隐藏入口）
 * @returns {boolean}
 */
export const getHasInvite = () => {
  const value = localStorage.getItem(HAS_INVITE_KEY);
  if (value === null) return false;
  return value === '1';
};

/**
 * 获取并校验有效的登录 UserId
 * 逻辑：如果处于登录态且未过期，则更新过期时间（滑动过期）并返回 ID
 */
export const getValidLoginId = () => {
  const status = localStorage.getItem(STATUS_KEY);
  const userId = localStorage.getItem(USER_ID_KEY);
  const expiry = localStorage.getItem(EXPIRY_KEY);

  if (status !== 'logged_in' || !userId || !expiry) return null;

  const now = Date.now();
  if (now > Number(expiry)) {
    // 已过期
    clearAuthStorage();
    return null;
  }

  // 【核心修复】：未过期则通过更新时间戳实现“滑动过期”
  const newExpiry = now + FIFTEEN_DAYS_MS;
  localStorage.setItem(EXPIRY_KEY, newExpiry.toString());
  return userId;
};

/**
 * 清除所有登录相关的本地存储
 */
export const clearAuthStorage = () => {
  localStorage.removeItem(USER_ID_KEY);
  localStorage.removeItem(PHONE_KEY);
  localStorage.removeItem(STATUS_KEY);
  localStorage.removeItem(EXPIRY_KEY);
  localStorage.removeItem(HAS_INVITE_KEY);
};
export const clearAllAuthData = () => {
  // 清除所有登录相关的持久化数据
  localStorage.removeItem('userId');
  localStorage.removeItem('token');
  localStorage.removeItem('userInfo');
  localStorage.removeItem('loginTimestamp');
  
  // 如果有其他业务缓存也可以一并清除
  console.log(">>> [Auth] 登录态已彻底清除");
};
// 获取当前有效的 ID (登录 ID 或 游客 ID)
export const getAnyUserId = () => {
  return localStorage.getItem('userId') || localStorage.getItem('guestId');
};
// 退出登录的清理逻辑
export const clearLoginData = () => {
  localStorage.removeItem('userId');
  localStorage.removeItem('token');
  localStorage.removeItem('loginTimestamp');
  // 注意：不要删除 guestId，它是登录接口的“敲门砖”
};
// 重新初始化游客 ID (如果连 guestId 都没有了，就生成一个)
export const initGuestId = () => {
  let gid = localStorage.getItem('guestId');
  if (!gid) {
    gid = `user_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    localStorage.setItem('guestId', gid);
  }
  return gid;
};